import React from "react";
import { Box, Card, Typography } from "@mui/material";
import { useCurrencySetting } from "@/hooks/useSetting";
import { useAppTheme } from "@/utils/theme";

interface RedemptionHistoryCardProps {
  amount: number;
  date: string;
}

const RedemptionHistoryCard: React.FC<RedemptionHistoryCardProps> = ({
  amount,
  date,
}) => {
  const theme = useAppTheme();
  const currencySetting = useCurrencySetting();

  const formattedAmount = `${currencySetting.mask || "£"}${amount.toFixed(2)}`;

  return (
    <Card
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "10px 16px",
        bgcolor: theme.palette.surface.light2,
        borderRadius: 2,
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          position="relative"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ minHeight: 40, minWidth: 40 }}
        >
          <img
            src="/assets/icons/star-icon.svg"
            alt="Redeemed"
            style={{ minHeight: 40, minWidth: 40 }}
          />
          <Typography
            variant="labelLarge"
            fontWeight="700"
            color="black"
            lineHeight={1}
            position="absolute"
            sx={{
              top: "55%",
              transform: "translateY(-50%)",
            }}
          >
            {currencySetting.mask || "£"}
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column">
          <Typography variant="subtitle1" fontWeight="bold">
            Redeemed {formattedAmount}
          </Typography>
          <Typography
            variant="labelSmall"
            color={theme.palette.textMain.dark2}
          >
            {date}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default RedemptionHistoryCard;
